import { useState, useCallback, useEffect } from "react";
import { useGeneralMessage } from "../../common/APICommon";
import { SetAuditTrail, SetAuditTrailBulk } from "../../components/Reports/AuditTrailReportEmployeeSetup";
import maintenanceSalaryCombinationCodeService from "../services/maintenanceSalaryCombinationCodeService";

export const useMaintenanceSalaryCombinationCode = ({ showGeneralMessage }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const fetchCodes = useCallback(async () => {
    setLoading(true);
    try {
      const res = await maintenanceSalaryCombinationCodeService.getAll();
      setData(res.data || []);
      setFilterData(res.data || []);
    } catch (err) {
      showGeneralMessage("Failed to load records", false);
    } finally {
      setLoading(false);
    }
  }, [showGeneralMessage]);

  useEffect(() => { fetchCodes(); }, [fetchCodes]);

  const getCodeById = async (id) => {
    setLoading(true);
    try {
      const res = await maintenanceSalaryCombinationCodeService.getById(id);
      return { success: true, data: res.data };
    } catch (err) {
      showGeneralMessage("Failed to fetch details", false);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const handleAction = async (actionFn, auditData, ...args) => {
    setLoading(true);
    try {
      const res = await actionFn(...args);
      if (Array.isArray(auditData)) await SetAuditTrailBulk({ data: auditData });
      else if (auditData) await SetAuditTrail(auditData);

      showGeneralMessage(res.data?.message || "Action successful", true);
      await fetchCodes();
      return { success: true };
    } catch (err) {
      showGeneralMessage(err.response?.data?.message || "Error", false);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const searchData = (value) => {
    if (!value) { setData(filterData); return; }
    const lower = value.toLowerCase();
    setData(filterData.filter(f =>
      f.code?.toLowerCase().includes(lower) ||
      f.id?.toString().includes(lower)
    ));
  };

  return {
    loading, data, searchData, getCodeById,
    createCode: (p, audit) => handleAction(maintenanceSalaryCombinationCodeService.create, audit, p),
    updateCode: (id, p, audit) => handleAction(maintenanceSalaryCombinationCodeService.update, audit, id, p),
  };
};